<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="steps-desc">
        <div class="steps-desc-left">
          <img src="~@/assets/quto-left.png" alt="">
        </div>
        <div class="steps-desc-center">
          合同签署包含：双录、风险揭示书签署、合同文件签署
        </div>
        <div class="steps-desc-right">
          <img src="~@/assets/quto-right.png" alt="">
        </div>
      </div>
      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">双录:</div>
        <div class="item-box-title">
          双录根据产品配置确定是否需要双录，若需要参照双录说明
        </div>
        <div class="item-box-slide">
          <cube-slide :showDots="false">
            <cube-slide-item>
              <img src="~@/assets/contract0.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">

            <div class="item-box-slide-desc-n">
              <span>01</span>/01
            </div>
            <div class="item-box-slide-desc-text">发起双录</div>

          </div>
        </div>
      </div>

      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">风险揭示书签署:</div>
        <div class="item-box-title">
          投资者需要对风险揭示书查看阅读并进行投资者声明确认，确认后进行签名、签章
        </div>
        <div class="item-box-slide">
          <cube-slide
            :initialIndex="slideIndex"
            :showDots="false"
            :autoPlay="false"
            @change="slideChange">
            <cube-slide-item>
              <img src="~@/assets/contract12.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/contract13.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/contact2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideIndex + 1}`}}</span>/03
            </div>
            <div class="item-box-slide-desc-text">
              {{['阅读风险揭示书', '签字', '签章'][slideIndex]}}
            </div>
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">合同文件签署:</div>
        <div class="item-box-title">
          投资者签署完风险揭示可直接签署合同文件，查看阅读合同文件，并进行签字、签章。
        </div>
        <div class="item-box-slide">
          <cube-slide :showDots="false">
            <cube-slide-item>
              <img src="~@/assets/contract11.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div class="item-box-slide-desc-n">
              <span>01</span>/01
            </div>
            <div class="item-box-slide-desc-text">合同文件签署</div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideNorIndex: 0,
      slideIndex: 0,
    };
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
    $_jumpSlideItem(index) {
      if (index < 2) {
        this.slideIndex = index + 1;
      } else {
        this.slideIndex = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.steps-desc {
  margin: 15px;
  color: #999;
  background: rgb(252, 229, 193);
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 15px 5px;
  font-size: 12px;
  align-content: center;
  .steps-desc-left,.steps-desc-right {
    img {
      width: 15px;
    }
  }
  .steps-desc-center {
    flex: .9;
  }
}
.item-box {
  margin-bottom: 30px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
    line-height: 18px;
    span {
      color: #FF9800;
    }
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
        font-size: 15px;
      }
    }
  }
}
</style>
